import React from "react";
import { withRouter } from "react-router-dom";
import BenificialOwnerComponent from "./BeneficialOwner.component";

const BenificialOwnerLanding = () => {
  return <BenificialOwnerComponent />;
};
export default withRouter(BenificialOwnerLanding);
